import './textual-banner/textual-banner';
import './news-carosuel/news';
import './title-description/title-description';
import './text-link-list/text-link-list';
import './simple-text/simple-text';
import './timeline/timeline';
import './attachments-banner/attachments-banner';
import './cards-list/card';
import './latest-courses/latest-courses';
import './link-banner/link-banner';
import './icon-text-list/icon-text-list';
import './icon-description-list/icon-description-list';
import './footer/footer';
import './article-item-list/article-item-list';
import './inner-banner/inner-banner';
import './feedback-banner/feedback-banner';
import './filters/filters';
import './topics-banner/topics-banner';
import './collection-of-entities/collection-of-entities';
import './banner-highlights-news/banner-highlights-news';

import ArticleBanner from './article-banner/article-banner';
import HighlightScopes from './highlight-scopes/highlight-scopes';
import IndexBanner from './index-banner/index-banner';
import HeroBanner from './hero-banner/hero-banner';
import Breadcrumb from './breadcrumb/breadcrumb';
import TabComponent from './tab-component/tab-component';
import CardGrid from './card-grid/card-grid';
import TableBanner from './table-banner/table-banner';
import IconLinkList from './icon-link-list/icon-link-list';
import Header from './header/header';
import Map from './map/map';
import DataView from './library-chart/library-chart';
import Newsletter from './newsletter/newsletter';
import Accordion from './accordion/accordion';
import HeroBannerAnimation from './hero-banner-animation/hero-banner-animation';
import DataList from './data-list/data-list';
import Error404 from './error404/error404';
import FeedbackModal from './feedback-modal/feedback-modal';
import ListAttachments from './list-attachments/list-attachments';
import GoToTop from './go-to-top/go-to-top';
import ArticleItemList from './article-item-list/article-item-list';
import ConnectionMap from "./connection-map/connection-map";

export function Components() {
    ArticleBanner();
    HighlightScopes();
    IndexBanner();
    HeroBanner();
    Breadcrumb();
    TabComponent();
    CardGrid();
    TableBanner();
    IconLinkList();
    Header();
    Map();
    DataView();
    HeroBannerAnimation();
    Newsletter();
    Accordion();
    DataList();
    FeedbackModal();
    ListAttachments();
    Error404();
    GoToTop();
    ArticleItemList();
    ConnectionMap();
}
